import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Settings = () => import('@/views/Settings')
const MobileApps = () => import('@/views/MobileApps')
const AccountProfile = () => import('@/views/AccountProfile')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')
const UserSessions = () => import('@/views/users/UserSessions')

// Screens
const Screens = () => import('@/views/editor/Screens')
const Screen = () => import('@/views/editor/Screen')
const Block = () => import('@/views/editor/Block')
const Blocks = () => import('@/views/editor/Blocks')

const OurPodcasts = () => import('@/views/podcasts/OurPodcasts')
const Podcasts = () => import('@/views/podcasts/Podcasts')
const Podcast = () => import('@/views/podcasts/Podcast')

const Episodes = () => import('@/views/podcasts/Episodes')
const Episode = () => import('@/views/podcasts/Episode')

const CrawlerTodo = () => import('@/views/crawler/Todo')
const CrawlerErrors = () => import('@/views/crawler/Errors')

const Links = () => import('@/views/links/Links')
const Link = () => import('@/views/links/Link')

const Tabs = () => import('@/views/editor/Tabs')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'blocks',
          meta: {
            label: 'Blocks'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Blocks',
              component: Blocks
            },
            {
              path: ':id',
              meta: {
                label: 'Block Details'
              },
              name: 'Block',
              component: Block
            }
          ]
        },
        {
          path: 'screens',
          meta: {
            label: 'Screens'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Screens',
              component: Screens
            },
            {
              path: ':id',
              meta: {
                label: 'Screen Details'
              },
              name: 'Screen',
              component: Screen
            }
          ]
        },
        {
          path: 'tabs',
          meta: {
            label: 'Tabs'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Tabs',
              component: Tabs
            },
          ]
        },
        {
          path: 'podcasts',
          redirect: '/podcasts/podcasts',
          name: 'Shows',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ourpodcasts',
              name: 'Our Podcasts',
              component: OurPodcasts
            },
            {
              path: 'podcasts',
              name: 'Podcasts',
              component: Podcasts
            },
            {
              path: 'podcasts/:id',
              meta: {
                label: 'Podcast Details'
              },
              name: 'Podcast',
              component: Podcast
            },
            {
              path: 'episodes',
              name: 'Episodes',
              component: Episodes
            },
            {
              path: 'episodes/:id',
              meta: {
                label: 'Episode Details'
              },
              name: 'Episode',
              component: Episode
            },
          ]
        },
        {
          path: 'crawler',
          name: 'Crawler',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'errors',
              name: 'Crawler Errors',
              component: CrawlerErrors
            },
            {
              path: 'todo',
              name: 'Crawler Todo',
              component: CrawlerTodo
            },
          ]
        },
        {
          path: 'links',
          name: 'Links',
          component: Links
        },
        {
            path: 'links/:id',
            meta: {
              label: 'Link Details'
            },
            name: 'Link',
            component: Link
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'account',
          name: 'Account profile',
          component: AccountProfile
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings
        },
        {
          path: 'mobileapps',
          name: 'Mobile Apps',
          component: MobileApps
        },
        {
          path: 'user-sessions',
          name: 'User-sessions',
          component: UserSessions,
        }
      ]
    }
  ]
}

